import React from 'react'
import '../css/generals/footer.css'
import { useTranslation } from 'react-i18next'

export default function Footer () {
  const { t } = useTranslation('footer')

  return (
    <footer className="main-footer">
      <strong className="rights">
        {t('paragraph1')}{' '}
        <a
          href="https://pixartargentina.com.ar/"
          target="_blank"
          rel="noreferrer"
        >
          {t('paragraph2')}
        </a>{' '}
        {t('paragraph3')}
      </strong>
    </footer>
  )
}
